<template>
  <!-- 无数据组件 -->
  <div id="notData">
    <div class="img-view">
      <template v-if="img">
        <img :src="img" alt="" />
      </template>
      <span style="margin-top: 24px">{{ topTitle }}</span>
      <template v-if="bottomTitle">
        <span>{{ bottomTitle }}</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "notData",
  props: {
    img: {
      type: String,
      default: "",
    },
    topTitle: {
      type: String,
      default: "暂无数据",
    },
    bottomTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
#notData {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 480px;
  .img-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 200px;
    height: auto;
    img {
      width: 240px;
      height: auto;
    }
    i {
      font-size: 100px;
      opacity: 0.15;
    }
    span {
      font-size: 15px;
      line-height: 22px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: rgba(165, 165, 165, 1);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/noData.vue